export default __webpack_public_path__ + "static/media/oscer-pres-shortness-of-breath.7ce01402.svg";